var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('icon-button',{attrs:{"id":_vm.id,"type":"white","icon":_vm.icon,"tooltip":_vm.tooltip,"button-class":_vm.isActive ? 'alphabetical-sort-button--active' : ''},on:{"click":_vm.cycle}})
}
var staticRenderFns = []

export { render, staticRenderFns }